import {defineSvg} from '@downforce/react/svg'

export const OptionsIcon = defineSvg({
    name: 'OptionsIcon',
    className: '',
    viewBox: '0 0 30 32',
    children: <>
        <path
            strokeWidth="0"
            d="M6.81602 10.8741L2.61902 7.5731L3.23702 6.78709L6.70802 9.51709L15.048 0.496094L15.782 1.17409L6.81602 10.8741Z"
        />
        <path
            strokeWidth="0"
            d="M13.645 15.9133H0.769043V3.23828H12.731V4.23828H1.76904V14.9133H12.645V7.92528L12.661 7.29628L6.81404 13.4293L4.34004 11.5313L4.94804 10.7373L6.71004 12.0893L13.728 4.72828L13.645 7.94428V15.9133Z"
        />
        <path
            strokeWidth="0"
            d="M6.81602 26.6221L2.61902 23.3211L3.23702 22.5351L6.70802 25.2651L15.048 16.2441L15.782 16.9231L6.81602 26.6221Z"
        />
        <path
            strokeWidth="0"
            d="M13.645 31.6633H0.769043V18.9883H12.731V19.9883H1.76904V30.6633H12.645V23.6743L12.661 23.0463L6.81404 29.1783L4.34004 27.2813L4.94804 26.4873L6.71004 27.8383L13.728 20.4783L13.645 23.6943V31.6633Z"
        />
        <path
            strokeWidth="0"
            d="M29.7311 3.23828H17.2931V4.23828H29.7311V3.23828Z"
        />
        <path
            strokeWidth="0"
            d="M29.7311 8.72266H17.2931V9.72266H29.7311V8.72266Z"
        />
        <path
            strokeWidth="0"
            d="M29.7311 14.209H17.2931V15.209H29.7311V14.209Z"
        />
        <path
            strokeWidth="0"
            d="M29.7311 19.6934H17.2931V20.6934H29.7311V19.6934Z"
        />
        <path
            strokeWidth="0"
            d="M29.7311 25.1777H17.2931V26.1777H29.7311V25.1777Z"
        />
        <path
            strokeWidth="0"
            d="M29.7311 30.6641H17.2931V31.6641H29.7311V30.6641Z"
        />
    </>,
})
